import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSessionWizard } from '../hooks/useSessionWizard';
import Step1Client from '../components/wizard/Step1Client';
import Step2ActType from '../components/wizard/Step2ActType';
import Step3Contract from '../components/wizard/Step3Contract';
import Step4Checklist from '../components/wizard/Step4Checklist';
import Step5Materials from '../components/wizard/Step5Materials';
const STEP_LABELS = ['Client', 'Acte', 'Contrat', 'Checklist', 'Matériaux'];

export default function SessionWizard() {
  const [params] = useSearchParams();
  // Return from ContractForm: ?sessionId=X&contractId=Y
  const returnSessionId = params.get('sessionId') ?? undefined;
  const returnContractId = params.get('contractId') ?? undefined;
  const isReturningFromContract = !!(returnSessionId && returnContractId);

  // Normal entry: ?clientId=X
  const initialClientId = isReturningFromContract ? undefined : (params.get('clientId') ?? undefined);
  const initialQuoteId = isReturningFromContract ? undefined : (params.get('quoteId') ?? undefined);

  const wizard = useSessionWizard(initialClientId, initialQuoteId);
  const { step } = wizard.state;
  const [resuming, setResuming] = useState(isReturningFromContract);

  useEffect(() => {
    if (returnSessionId && returnContractId) {
      wizard.resumeAfterContract(returnSessionId, returnContractId)
        .catch(console.error)
        .finally(() => setResuming(false));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (resuming) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="w-8 h-8 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto p-4 space-y-6">
      {/* Progress bar */}
      <div className="space-y-2">
        <div className="flex gap-1">
          {STEP_LABELS.map((_, i) => (
            <div
              key={i}
              className={`flex-1 h-1.5 rounded-full transition-colors ${i + 1 <= step ? 'bg-primary' : 'bg-muted'}`}
            />
          ))}
        </div>
        <p className="text-sm text-muted-foreground">
          Étape {step}/5 — {STEP_LABELS[step - 1]}
        </p>
      </div>

      {/* Step content */}
      {step === 1 && <Step1Client wizard={wizard} />}
      {step === 2 && <Step2ActType wizard={wizard} />}
      {step === 3 && <Step3Contract wizard={wizard} />}
      {step === 4 && <Step4Checklist wizard={wizard} />}
      {step === 5 && <Step5Materials wizard={wizard} />}
    </div>
  );
}
